import React, {useState, useEffect} from "react";
import {Container, Alert, Form, Button} from "react-bootstrap";
import Auth from "../libs/Auth";

import {useDispatch} from "react-redux";
import {startLoading, stopLoading} from "../../admin";

function Activate({location, history}) {
    document.body.classList.add('bg-gradient-primary');

    const dispatch = useDispatch();
    const [activated, setActivated] = useState(false);
    const [email, setEmail] = useState('');
    const [resent, setResent] = useState(false);

    // link format: /verify/{token}/{userId}/{expires}
    useEffect(() => {
        const pathParts = location.pathname.split('/');
        const hash = pathParts[2];
        const id = pathParts[3];
        const expires = pathParts[4];

        dispatch(startLoading());

        Auth.confirm(id, hash, expires)
            .then(() => setActivated(true))
            .catch(() => setActivated(false))
            .finally(() => dispatch(stopLoading()));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (activated) {
            const timeout = setTimeout(() => history.push('/'), 5000);
            return () => clearTimeout(timeout);
        }
    }, [activated, history]);

    const resend = (event) => {
        event.preventDefault();
        Auth.resendActivation(email).then(() => setResent(true)).catch(() => setResent(false));
    };

    const ActivatedNotice = () => (
        <Alert variant="success" className="mt-5">
            Activation successful, you can log in
        </Alert>
    );

    const NotActivatedNotice = () => (
        <Alert variant="danger" className="mt-5">
            Activation failed, the link has expired or the account is already activated.
            If your account is not active yet, enter your e-mail address to get a new link.
            <Form className="mt-3" onSubmit={resend}>
                <Form.Group controlId="resendEmail">
                    <Form.Control type="email" placeholder="E-mail address" value={email}
                                  onChange={(event) => setEmail(event.target.value)} required/>
                </Form.Group>
                <Button type="submit" variant="primary">Send a new activation link</Button>
                {resent && <p className="mt-3 mb-0">If that address needs activation, a new link is on its way.</p>}
            </Form>
        </Alert>
    );

    return (
        <Container>
            {activated ? <ActivatedNotice /> : <NotActivatedNotice /> }
        </Container>
    );
}

export default Activate;
